export default __webpack_public_path__ + "static/media/ic-export.a7a73c59.svg";